
import { Image } from "utils"
import SETTINGS from "settings"

const sun = `

//ignoring (or not even declaring) this variable crashes PIXI:
varying vec2 vTextureCoord;
//comments at uniform section are NOT working when it's under PIXI ...

#define M_PI 3.1415926535897932384626433832795

uniform float iTime;
uniform vec3 center_1;
uniform vec3 end_1;
uniform vec3 center_2;
uniform vec3 end_2;

void main()
{
    vec2 sun_center = vec2( 0.35, 0.4 );
    
    vec2 d = vTextureCoord - sun_center;
    
    float tau = d.x == 0.0 ? M_PI / 4.0 : atan( d.y / d.x );
    tau -= mod( iTime * 1.2, M_PI * 2.0 );
    
    //how much beams:
    const float W = M_PI / 10.0;
    
    float interp = length( d ) * 2.0;
    
    //color 1:
    if ( mod( tau, W ) < W / 2.0 )
    {
        gl_FragColor = vec4( mix( center_1, end_1, interp ), 1.0 );
    }
    //color 2:
    else
    {
        gl_FragColor = vec4( mix( center_2, end_2, interp ), 1.0 );
    }
}
`

export default function( space, container, params )
{
    //any image just needed to make PIXI work - couldn't run shader without any textures:
    const cloth = Image( "res/common/network_indicator.png" )
    cloth.width = SETTINGS.canvas.width
    cloth.height = SETTINGS.canvas.height
    
    const shader = new PIXI.Filter(
        null,
        sun,
        {
            iTime : 0.0,
            center_1 : params.center_1,
            end_1 : params.end_1,
            center_2 : params.center_2,
            end_2 : params.end_2,
        }
    )
    shader.uniforms.iTime = 0.0
    shader.uniforms.center_1 = params.center_1
    shader.uniforms.end_1 = params.end_1
    shader.uniforms.center_2 = params.center_2
    shader.uniforms.end_2 = params.end_2
    //shader.uniforms.period = 1.0;
    space.s( "size" ).on( size => {
        /*cloth.width = size.x
        cloth.height = size.y*/
        console.log( "W:", size.x, "H:", size.y )
        //shader.uniforms.iResolution = [ size.x, size.y ]
    } )
    space.s( "ticker" )
        .with( params.$complete, ( seconds, complete ) => ({ seconds, complete }) )
        .filter( ({ seconds, complete }) => ! complete )
        .on( ({ seconds }) => {
            shader.uniforms.iTime += seconds
            
            //shader.uniforms.period += seconds
            //shader.uniforms.period %= Math.Pi * 2.0
    } )
    
    cloth.filters = [ shader ]
    container.addChild( cloth )
}





// WEBPACK FOOTER //
// ./src/library/progressive_jackpot/sun.es6